import { useTitle } from "@/hooks/use-title.hook.ts";
import { PerformanceReviewTemplateEditDetailsPage } from "@/pages/talent/performance-reviews/templates/edit/pages/PerformanceReviewTemplateEditDetailsPage.tsx";
import { PerformanceReviewTemplateEditQuestionsPage } from "@/pages/talent/performance-reviews/templates/edit/pages/PerformanceReviewTemplateEditQuestionsPage.tsx";
import {
  PerformanceReviewTemplateEditPageStep,
  useTemplateEditPage,
} from "@/pages/talent/performance-reviews/templates/edit/performance-review-template-edit.tsx";
import { PerformanceReviewTemplateTitleSlot } from "@/pages/talent/performance-reviews/templates/edit/PerformanceReviewTemplateTitleSlot.tsx";
import { usePerformanceReviewTemplateById } from "@/queries/performance-reviews/use-performance-review-template.query.ts";
import { Button, FullScreenPage, Skeleton } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const PerformanceReviewTemplateEditPage = () => {
  const { t } = useTranslation();
  const { id, step } = useParams();

  const { confirmExit } = useTemplateEditPage();

  const { data: template } = usePerformanceReviewTemplateById(id ? parseInt(id) : undefined, !!id);

  useTitle(template?.title, t("performance_review:performance_review_template"));

  const currentStep = useMemo(() => {
    if (step) {
      return step as PerformanceReviewTemplateEditPageStep;
    }
    return PerformanceReviewTemplateEditPageStep.details;
  }, [step]);

  if (template) {
    if (currentStep == PerformanceReviewTemplateEditPageStep.details) {
      return <PerformanceReviewTemplateEditDetailsPage key={template.id} template={template} />;
    } else if (currentStep == PerformanceReviewTemplateEditPageStep.questions) {
      return <PerformanceReviewTemplateEditQuestionsPage template={template} />;
    }
  }

  return (
    <FullScreenPage
      backSlot={
        <Button variant={"secondary"} size={"lg"} onClick={confirmExit}>
          {t("common:exit")}
        </Button>
      }
      titleSlot={
        <PerformanceReviewTemplateTitleSlot step={PerformanceReviewTemplateEditPageStep.details} />
      }
      isCenterVertical={false}
      contentSize={"md"}
    >
      <Skeleton className={"w-full h-10"} />
    </FullScreenPage>
  );
};
